module.exports = __webpack_public_path__ + "media/guide_movie.b3284a50.mp4";